import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6cadbda5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginContainer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_3 = { class: "formContainer p-5 position-relative" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_6 = { class: "mt-5 text-center" }
const _hoisted_7 = { class: "mt-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        type: "h2",
        localizedKey: "Welcome Back",
        text: "Welcome Back",
        class: "text-center"
      }),
      _createElementVNode("form", {
        class: "mt-5",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
      }, [
        _createVNode(_component_form_field, {
          type: "email",
          modelValue: _ctx.languageCredential.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.languageCredential.username) = $event)),
          placeholderKey: "Email",
          placeholderValue: "Email",
          labelKey: "Email",
          labelValue: "Email"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_form_field, {
          class: "pb-3",
          type: "password",
          modelValue: _ctx.languageCredential.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.languageCredential.password) = $event)),
          placeholderKey: "Password",
          placeholderValue: "Password",
          labelKey: "Password",
          labelValue: "Password"
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary text-center justify-content-center w-100 mt-4",
          disabled: _ctx.disabled
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Login",
            text: "Login"
          })
        ], 8, _hoisted_4)
      ], 32),
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: "/loginByDomain",
        class: "btn btn-secondary text-center justify-content-center w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_localized_text, {
            localizedKey: "Login by company domain",
            text: "Login by company domain"
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_localized_text, {
          class: "grey d-block mb-1",
          localizedKey: "Don't you have an account yet?",
          text: "Don't you have an account yet?"
        }),
        _createVNode(_component_router_link, { to: "/register" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Sign up",
              text: "Sign up"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/provider-login",
          class: "grey fs_14"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Provider Login",
              text: "Provider Login"
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}